export default "__VITE_ASSET__10dcb884__"